<template>
	<div class="role">
		<div class="left-menus" v-if="adminId == 1 && tel == ''">
			<div class="left-list">
				<div :class="enpId == item.id ? 'left-enp-item-active' : 'left-enp-item'" v-for="item in companyList" :key="item.id" @click="handleEnp(item.id)">
					<div class="enp-item-name">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div class="role-wrap" v-if="!isEdit">
			<!-- <div class="qjc-flex query-wrap">
				<el-input class="search-input" v-model="nowMobile" @input="accountInput"  @keyup.enter.native='query' placeholder="请输入病人手机号">
					<div class="search-icon" slot="prefix">
						<i class="el-icon-search"></i>
					</div>
				</el-input>
				<el-button @click="query" :loading="submiting" class="query-btn qjc-fts-16">查询</el-button>
			</div> -->
			<el-table
				:data="user"
				class="list"
			>
			
			<!-- :height="mainHeight-214+'px'" -->
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<!-- <el-table-column
					label="套餐内容"
					width="200px"
					class-name="package"
				>
					<template slot-scope="scope">
						<div class="package-cell">
							{{scope.row.package == '1' ? '健康100' : scope.row.package == '2' ? '自由定制' : scope.row.package == '3' ? '馨享母婴' : scope.row.package == '5' ? 'AI健康' : ''}}
						</div>
					</template>
				</el-table-column> -->
				<el-table-column
					prop="mobile"
					width="140px"
					label="病人手机号"
					class-name="mobile"
				>
				<template slot-scope="scope">
					{{scope.row.mobile ? scope.row.mobile : '--'}}
				</template>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="订单编号"
					class-name="mobile"
				>
				<template slot-scope="scope">
					{{scope.row.order_no ? scope.row.order_no : '--'}}
				</template>
				</el-table-column>
				<el-table-column
					prop="mobile"
					label="订单时间"
					class-name="mobile"
				>
				<template slot-scope="scope">
					{{scope.row.created_at ? scope.row.created_at : '--'}}
				</template>
				</el-table-column>
				<el-table-column
					prop="sex"
					label="性别"
					class-name="sex"
					width="100px"
				>
					<template slot-scope="scope">
						{{scope.row.sex == '1' ? '男' : scope.row.sex == '2' ? '女' : ''}}
					</template>
				</el-table-column>
				<el-table-column
					label="负责医生"
					class-name="doctor"
					width="100"
				>
					<template slot-scope="scope">
						{{scope.row.doctor?scope.row.doctor:'--' }}
					</template>
				</el-table-column>
				<el-table-column
					prop="is_finish"
					label="状态"
					class-name="is_finish"
				>
					<template slot-scope="scope">
						<div class="finished">
							已完成
						</div>
						<!-- <div class="finish-not" v-if="scope.row.is_finish == 1">
							未体检
						</div>
						<div class="finished" v-if="scope.row.is_finish == 80">
							已完成
						</div> -->
					</template>
				</el-table-column>
				<el-table-column
					prop="action"
					label="操作"
					class-name="sex"
				>
					<template slot-scope="scope">
						<div class="action-btn" @click="handleUpdate(scope.row)">
							修改
						</div>
						<!-- <div class="action-btn" v-if="scope.row.is_finish == 1 && scope.row.package != '3'" @click="handleUpdateBo(scope.row)">
							录入
						</div>
						<div class="action-btn" v-if="scope.row.is_finish == 80 && scope.row.package != '5'" @click="handleUpdate(scope.row)">
							修改
						</div> -->
					</template>
				</el-table-column>
				
				<!-- <el-table-column
					class-name="oper"
					align="center"
				>
					<template slot-scope="scope">
						<el-button @click="lookReport(scope.row)" type="text">查看报告</el-button>
						<el-button @click="download(scope.row.id)" type="text">下载报告</el-button>
						<el-button @click="print(scope.row.id)">一键打印</el-button>
					</template>
				</el-table-column> -->
				
			</el-table>
				
			<!-- 分页 -->
				<el-pagination
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
					hide-on-single-page
					:current-page.sync="pager.page"
					:page-count="pager.pagecount"
					:page-size="pager.pagesize"
					:total="pager.count"
					@current-change="pageChange">
				</el-pagination>
		</div>
		
		<div class="open-wrap" v-if="isEdit">
			<doctor-Insert v-if="!isMuying" :isBo="isBo" :dataId="id" :doctor_id="doctor_id" :tel="tel" type="update" :clearData="clearData" ></doctor-Insert>
			<!-- <new-Insert-My v-if="isMuying" :dataId="id"  type="update" :clearData="clearData" ></new-Insert-My> -->
		</div>
	</div>
</template>

<script>
	import { adminRole, printBatchQuery, mainDataQuery, getDoctorOrder } from "@/utils/axios"
	import DoctorInsert from '@/components/DoctorInsert'
	// import NewInsertMy from '@/components/NewInsert/muying'
	
	export default{
		name: 'adminDataUpdate',
		components: {
			DoctorInsert
			// NewInsertMy
		},
		data() {
			return {
				isEdit: false,
				isMuying: false,
				id: '',
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
				formData: {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: '',
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"kdis": "K01", "level": "0"},
						{"kdis": "K02", "level": "0"},
						{"kdis": "K03", "level": "0"},
						{"kdis": "K04", "level": "0"},
						{"kdis": "K05", "level": "0"},
						{"kdis": "K06", "level": "0"},
						{"kdis": "K07", "level": "0"},
						{"kdis": "K08", "level": "0"},
						{"kdis": "K09", "level": "0"},
						{"kdis": "K10", "level": "0"},
						{"kdis": "K11", "level": "0"},
						{"kdis": "K12", "level": "0"},
						{"kdis": "K13", "level": "0"},
						{"kdis": "K14", "level": "0"},
						{"kdis": "K15", "level": "0"},
						{"kdis": "K16", "level": "0"},
						{"kdis": "K17", "level": "0"},
						{"kdis": "K18", "level": "0"},
						{"kdis": "K19", "level": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: ''// 当前后台操作人手机号
				},
				rules: {
					name: [
						{ required: true, message: '角色名称不能为空', trigger: 'blur' }
					],
					power: [
						{ required: true, message: '请至少选择一项', trigger: 'change' }
					]
				},
				user: [],// 客户信息
				
				submiting: false,//正在请求
				
				pager: {
					count: 0,
					page: 1,// 默认第一页
					pagecount: 0,
					pagesize: 12//默认一页12条数据
				},
				
				nowMobile: '',// 存储当前已查询企业用户id或手机号
				isBo: false,
				
				adminId: '',
				doctor_id: '',
				companyList: [],
				enpId: '',
				tel: '',
			}
		},
		mounted() {
			let adminId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).issupper : '0'
			this.adminId = adminId
			// 获取企业列表
			if(adminId == 1) {
				this.handleEnpList()
			} else {
				this.getList()
			}
			// this.getList()
		},
		watch:{
			
		},
		methods: {
			handleEnpList() {
				getDoctorOrder({act: 'doctor-list'}).then((res) => {
					if(res.code == 200){
						this.companyList = res.data;
						this.companyList.unshift({id: '0', name: '全部'})
						this.enpId = res.data[0].id
						
						getDoctorOrder({
							act: '',
							doctor_id: this.enpId,
							startat: '',
							endat: '',
							page: this.pager.page,
							pagesize: this.pager.pagesize
						}).then(res => {
							if(res.code == 200){
								// 历史记录列表数据
								let list = res.data.data;
								
								this.user = list
								// 分页
								var pager = res.data.pager;
								for(var key in pager){
									pager[key] = parseInt(pager[key]);
								}
								this.pager = pager;
							}else{
								this.$myAlert({
									type: 'fail',
									content: res.msg
								});
							}
						});
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleEnp(id) {
				this.enpId = id
				this.pager.page = 1
				getDoctorOrder({
					doctor_id: id,
					act: '',
					startat: '',
					endat: '',
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}).then(res => {
					if(res.code == 200){
						// 历史记录列表数据
						let list = res.data.data;
						this.user = list
						// 分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			accountInput(val) {
				let codeReg = new RegExp("[A-Za-z0-9]+");
				let len = val.length;
				let str = '';
				for(let i = 0; i < len; i++){
					if(codeReg.test(val[i])) {
						str+=val[i]
					}
				}
				this.nowMobile = str
				this.getList();
			},
			clearData() {
				this.formData = {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: '',
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"kdis": "K01", "level": "0"},
						{"kdis": "K02", "level": "0"},
						{"kdis": "K03", "level": "0"},
						{"kdis": "K04", "level": "0"},
						{"kdis": "K05", "level": "0"},
						{"kdis": "K06", "level": "0"},
						{"kdis": "K07", "level": "0"},
						{"kdis": "K08", "level": "0"},
						{"kdis": "K09", "level": "0"},
						{"kdis": "K10", "level": "0"},
						{"kdis": "K11", "level": "0"},
						{"kdis": "K12", "level": "0"},
						{"kdis": "K13", "level": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: '',// 当前后台操作人手机号
				}
			},
			
			query() {
				// 正在请求
				if(this.nowMobile.trim() != '') {
					this.submiting == true;
					this.pager.page = 1;
					this.getList();
				}
			},
			
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			
			getList() {
				getDoctorOrder({
					act: '',
					mobile: this.nowMobile,
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}).then(res => {
					if(res.code == 200){
						this.submiting == false;
						if(res.data.data.length == 0){
							this.user = [];
							this.pager = {
								count: 0,
								page: 1,// 默认第一页
								pagecount: 0,
								pagesize: 12//默认一页12条数据
							}
							
						}else{
							this.user = res.data.data;
							//分页
							var pager = res.data.pager;
							for(var key in pager){
								pager[key] = parseInt(pager[key]);
							}
							this.pager = pager;
						}
					}else{
						this.submiting == false;
						this.$myAlert({
							type: 'fail',
							content: res.msg,
						});
					}
				});
			},
			hanleLoadAll() {
				this.nowMobile = '',
				this.getList();
			},
			handleUpdateBo(row) {
				this.id = row.id
				this.isBo = true
				this.isEdit = true;
			},
			
			handleUpdate(row) {
				// 数据修改
				this.id = row.id
				this.tel = row.mobile;
				this.doctor_id = row.admin_id;
				this.isBo = false
				this.isEdit = true;
			},
			
		}
	}
</script>

<style scoped>
	/* .role >>> .el-table th {
		height: 38px;
		padding: 0;
		background-color: #F7F9FC;
	}
	.role >>> .el-table td {
		height: 38px;
		padding: 0;
	} */
	
	.query-wrap >>> .el-input__inner {
		height: 36px;
		line-height: 36px;
	}
	.role >>> .el-table--fit {
		/* border-bottom: 1px solid #eeeeee !important; */
	}
	.role >>> .el-table__fixed-right::before, .el-table__fixed::before {
		height: 0 !important;
	}
	.role >>> .el-table td, .role >>> .el-table th.is-leaf {
		border-bottom: none;
	}
</style>
<style lang="scss" scoped>
	.role{
		position: relative;
		display: flex;
		padding: 0 24px;
		width: 100%;
		height: 100%;
		overflow-y: auto;
		border: 12px solid #F2F4FA;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px 0;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				
				&:hover {
					color: #7A92FB;
				}
			}
			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}
			
			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
			
			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			
			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}
		
		.role-wrap {
			position: relative;
			// width: 100%;
			// height: 100%;
			
			min-width: 1048px;
			height: 100%;
			flex: 1;
			padding: 28px 24px;
			overflow: auto;
		}
		.query-btn {
			width: 72px;
			height: 36px;
			line-height: 36px;
			font-size: 15px;
			padding: 0;
			margin-left: 16px;
			border: none;
			color: #fff;
		}
		
		.list{
			margin-top: 16px;
			
			&::before{
				display: none;
			}
			.el-button{
				font-size: 14px;
				padding: 6px 8px;
				font-weight: 400;
				
				+.el-button{
					margin-left: 24px;
				}
			}
			
			.package-cell {
				white-space:nowrap;
				overflow:hidden;
				text-overflow:ellipsis;
			}
		}
		
		.action-btn {
			font-size: 14px;
			// font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 400;
			color: #6883FB;
			cursor: pointer;
			display: inline-block;
			
			&:hover {
				color: #7a92fb;
			}
		}
		.action-btn-end {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #B4BBCC;
			cursor: pointer;
		}
		
		.foot-pagination {
			// position: absolute;
			// bottom: 0;
			width: 100%;
			padding-bottom: 20px;
			// height: 80px;
		}
		.pagination{
			// position: absolute;
			// bottom: 0;
			width: 100%;
			margin-top: 24px;
			text-align: center;
		}
		
		.search-input {
			width: 458px;
			height: 34px;
		}
		
		.search-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 26px;
			height: 36px;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					padding: 9px 15px;
				}
			}
		}
	}
	
	.finish-not {
		position: relative;
		padding-left: 12px;
		
		&::before {
			content: '';
			position: absolute;
			top: 8px;
			left: 0;
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: #FF5219;
		}
	}
	
	.finished {
		position: relative;
		padding-left: 12px;
		
		&::before {
			content: '';
			position: absolute;
			top: 8px;
			left: 0;
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: #38E019;
		}
	}
	
	.empty-wrap {
		padding: 100px 0;
	}
	.empty-img {
		width: 338px;
		height: 218px;
	}
</style>
